






















































































































































import VueOptions from '@utils/VueOptions'
import Modal from '@components/Modal'
import WizardService from '@services/Wizard'
import CalendarService from '@services/CalendarService'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import MediaSelector from '@ui/MediaSelector'
import states from '@assets/states.json'

settings =
  name: 'VenueOverviewStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      Modal,
      StepContainer,
      MediaSelector,
    }

    data: ->
      name: ''
      display: 'venues'
      selectedKeys: []

      options: [
        {
          id: 1,
          title: 'In Person Event',
          description: 'Concerts, Festivals, Events',
          detail: 'Events that happen on specific date(s) or time(s) such as a concert, race, or festival',
          imgUrl: 'https://wallpaperbat.com/img/299291-party-wallpaper-top-free-party-background.jpg',
          prototype: 'in_person_venue',
          navTo: 'venue-onsite-form',
        },
        # {
        #   id: 2,
        #   title: 'Remote/Online Event',
        #   description: 'Webinars, Streams, Videos',
        #   detail: 'Virtual events that don’t happen in-person such as a virtual race',
        #   imgUrl: 'https://media.istockphoto.com/photos/happy-asian-woman-recording-video-for-her-beauty-blog-picture-id1281654797?b=1&k=20&m=1281654797&s=170667a&w=0&h=qBhVn62BPfq6DwsBx4fXwMlZTpyKs4Ewp5GBxa012xs=',
        #   prototype: 'remote_venue',
        #   navTo: 'venue-remote-form',
        # },
        {
          id: 3,
          title: 'Ongoing Opportunity',
          description: 'Availability at a Building, Park, Mall',
          detail: 'Venues that have consistent availability such as a zoo, apartment complex, co-working office, or mall',
          imgUrl: 'https://i.insider.com/5e6a4070e4f9fe353a0e3655?width=700',
          prototype: 'in_person_venue',
          navTo: 'venue-ongoing-form',
        },
      ]

      dailyReachModal:
        show: false
        reach: null
        dayOptions: null

      mediaModal:
        show: false

    mounted: ->
      @initialize()

    computed:
      audienceAvailabilities: -> @wizard.audienceSetData.audience_availabilities
      # hasAudienceAvailabilities: -> @audienceAvailabilities.length > 0
      audienceAvailabilitiesTableData: -> @audienceAvailabilities

      listingClass: -> @wizard.audienceSetData.listing_class
      venueFormStepName: ->
        steps =
          'in_person': 'venue-onsite-form'
          'remote': 'venue-remote-form'
          'ongoing': 'venue-ongoing-form'
        steps[@listingClass]

      actionsForMediaSelector: ->
        onUpload: @onUploadMedia
        onDone: @selectMedia

    methods:
      hiNavToFormStep: (stepName) ->
        @wizard.navToStepName stepName

      hiEditVenue: (audienceAvailability) ->
        @wizard.setSelectedAudienceAvailabilityKey audienceAvailability.key
        @wizard.navToStepName @venueFormStepName

      hiEditCalendar: (audienceAvailability) ->
        @wizard.setSelectedAudienceAvailabilityKey audienceAvailability.key
        @wizard.navToStepName 'venue-calendar'

      hiRemoveAudienceAvailability: (audienceAvailability) ->
        @wizard.audienceSetData.audience_availabilities = @audienceAvailabilities.filter((item) => item.key isnt audienceAvailability.key)
        @wizard.syncAndSave()

      hiEditReach: (audienceAvailability) ->
        calendar = @wizard.lookupCalendar audienceAvailability.calendar_key
        dayOptions = CalendarService.dayOptionsForEvents calendar.events
        reach = {}

        for option in dayOptions
          day = option.value
          reach[day] = audienceAvailability.daily_reach[day]
          reach[day] ||= null

        @dailyReachModal = { show: true, audienceAvailability, reach, dayOptions }

      hiCloseDailyReachModal: ->
        @closeDailyReachModal()

      hiSaveDailyReachModal: ->
        { audienceAvailability, reach } = @dailyReachModal
        audienceAvailability.daily_reach = reach
        @wizard.syncAndSave()
        @closeDailyReachModal()

      hiSelectionChange: (selection) ->
        @selectedKeys = selection.map((audienceAvailability) -> audienceAvailability.key)

      hiOpenMediaSelector: (audienceAvailability) ->
        @mediaModal =
          show: true
          selectedKeys: [audienceAvailability.key]
          images: audienceAvailability.images

      hiOpenMediaSelectorForSelection: ->
        @mediaModal = { show: true, selectedKeys: @selectedKeys }

      hiRemoveImage: (url, audienceAvailability) ->
        audienceAvailability.images = audienceAvailability.images.filter((image) -> image isnt url)
        @wizard.syncAndSave()

      initialize: ->
        @wizard.removeSelectedAudienceAvailabilityKey()
        @autoNavToVenueForm()

      autoNavToVenueForm: ->
        return if @audienceAvailabilities.length > 0
        primaryType = @wizard.audienceSetData.pitch.primary_type
        ongoingTypes = ['coworking', 'conventional_housing', 'university_housing']
        stepName = if primaryType in ongoingTypes then 'venue-ongoing-form' else 'venue-onsite-form'
        @wizard.navToStepName stepName

      closeDailyReachModal: ->
        @dailyReachModal.show = false

      selectMedia: (selectedImages) ->
        for item in @audienceAvailabilities
          continue unless item.key in @mediaModal.selectedKeys
          item.images = Array.from(new Set([...selectedImages, ...item.images]))
        @wizard.syncAndSave()
        @$refs.audienceAvailabilitiesTable?.clearSelection()

      onUploadMedia: (file) ->
        @wizard.fetch 'supplier_media_kit'

      hasCalendarForAudienceAvailability: (audienceAvailability) ->
        calendar = @wizard.lookupCalendar audienceAvailability.calendar_key
        dayOptions = CalendarService.dayOptionsForEvents(calendar.events || [])
        dayOptions.length > 0

      formatCalendar: (calendar) ->
        return '-' unless calendar.key
        dayOptions = CalendarService.dayOptionsForEvents calendar.events
        days = dayOptions.map((day) => day.label)
        return '-' unless days.length
        # if saturday and sunday => Weekend
        # if monday...friday => Weekdays
        days.join(', ')

      formatAddress: (venue) ->
        { city, state } = venue.address
        fu = key for key, value of states when value is state
        return '-' if !city and !fu
        "#{city}, #{fu}"

      formatDay: (day) ->
        @dailyReachModal.dayOptions.find((option) -> option.value is day).label

      sumReach: (reach) ->
        Object.values(reach).reduce(((acc, value) -> acc + parseInt(value)), 0)

export default VueOptions.vue settings
